import React from "react";
import io from "socket.io-client";
import { API_BASE } from "../services/http";
import { getToken } from "../services/auth";

// Connect to the Socket.IO server embedded in soroby-api.
// The server lives on the same host as the REST API — derive the origin from
// the hardcoded API base URL so switching http.js between local/prod is the
// only change needed.
const apiOrigin = API_BASE.replace(/\/api\/.*$/, "")

export const socket = io(apiOrigin, {
  auth: { token: getToken() }
})

const SocketContext = React.createContext(socket);
export default SocketContext;
